import { convertUnit, formatQty, parseQty, renderNote } from '@/qty';
import type { Ingredient, UnitSystem } from '@/types';
import { Checkbox } from './Checkbox';

interface Props {
  ingredient: Ingredient;
  multiplier: number;
  unitSystem: UnitSystem;
  checked: boolean;
  onToggle: () => void;
}

const title = (s: string): string => s.replace(/\b\w/g, (c) => c.toUpperCase());

export function IngredientItem({ ingredient, multiplier, unitSystem, checked, onToggle }: Props) {
  const { quantity, unit, name, note, amountNote, fixed, recipe } = ingredient;
  const scaled = parseQty(quantity) * (fixed ? 1 : multiplier);
  const { qty: cQty, unit: cUnit } = unit
    ? convertUnit(scaled, unit, unitSystem)
    : { qty: scaled, unit };
  const displayQty = quantity ? formatQty(cQty, cUnit) : '';
  const amount = [displayQty, cUnit].filter(Boolean).join(' ');
  const renderedNote = renderNote(note, scaled);
  const renderedAmountNote = renderNote(amountNote, scaled);
  const parenContent = [amount, renderedAmountNote].filter(Boolean).join(', ');
  const displayName = title(name);
  return (
    <li class={`checklist__item ${checked ? 'checklist__item--done' : ''}`} onClick={onToggle}>
      <Checkbox checked={checked} />
      <span>
        {recipe ? (
          <a href={`/r/${recipe}`} onClick={(e) => e.stopPropagation()}>
            {displayName}
          </a>
        ) : (
          displayName
        )}
        {renderedNote ? `, ${renderedNote}` : ''}
        {parenContent ? <span class="amount"> ({parenContent})</span> : null}
      </span>
    </li>
  );
}
